<template>
  <div class="mode-container">
    <div v-for="item in cardList" :key="item.src">
      <img @click="toggleIcon(item)" v-if="cardVal.includes(item.val)" :src="item.src" alt=""  >
    </div>
  </div>
</template>

<script>
const card_icon = require('@/assets/listnoselect.png')
const card_active_icon = require('@/assets/listselect.png')
const list_icon = require('@/assets/arrnoselect.png')
const list_active_icon = require('@/assets/arrselect.png')
const map_icon = require('@/assets/public/map_point.png')
export default {
  model: {
    prop: 'cardVal',
    event: 'change'
  },
  props: {
    cardVal: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      cardList: [
        { src: card_icon, val: 1, name: 'CARD' },
        { src: card_active_icon, val: 2 , name: 'CARD'},
        { src: list_icon, val: 3, name: 'TABLE' },
        { src: list_active_icon, val: 4, name: 'TABLE' },
        { src: map_icon, val: 5, name: 'MAP' },
      ]
    };
  },
  mounted() {},
  methods: {
    // 卡片模式切换
    toggleIcon(data) {
      const { name } = data
      this.$emit('changeMode', name)
    }
  },
};
</script>

<style lang="scss" scoped>
.mode-container {
  display: flex;
  align-items: center;
  > div {
    position: relative;
    &::after {
      position: absolute;
      content: '';
      top: 1px;
      width: 1px;
      background: #E4E7ED;
      left: 39px;
      bottom: -1px;
    }
    img {
      width: 16px;
      height: 16px;
      cursor: pointer;
      margin: 0 12px;
      vertical-align: middle;
    }
    &:last-child {
      &::after {
        top: 5px;
        bottom: 3px;
        width: 0;
      }
      img {
        width: 30px;
        height: 26px;
      }
    }
  }
  

}
</style>
